export default [
  /**
   * 选择就诊人
   */
  {
    path: '/renewal/compat',
    component: () => import('./views/compat')//新版
  },
  {
    path: '/renewal',
    component: () => import('./views/v3')//新版
    // component: () => import('./index2')//新版
    // component: () => import('./index')
  },
  /**
   * 科室
   */
  {
    path: '/renewal/dept',
    component: () => import('./dept')
  },
  /**
   * 须知
   */
  {
    path: '/renewal/pre',
    component: () => import('./pre')
  },
  /**
   * 申请须知
   */
  {
    path: '/renewal/pre2',
    component: () => import('./views/pre2')
  },
  /**
   * 搜索
   */
  {
    path: '/renewal/search',
    component: () => import('./search')
  },
  /**
   * 选择药品
   */
  {
    path: '/renewal/xzyp',
    component: () => import('./xzyp')
  },
  /**
   * 创建成功，等待支付
   */
  {
    path: '/renewal/result',
    component: () => import('./result')
  },
  /**
   * 选择药品
   */
  {
    path: '/renewal/drug',
    component: () => import('./views/drug')
  },
  /**
   * 提交-step1
   */
  {
    path: '/renewal/confirm/1',
    component: () => import('./views/confirm/1')
  },
  /**
   * 提交-step2
   */
  {
    path: '/renewal/confirm/2',
    component: () => import('./views/confirm/2')
  },
  /**
   * 罕见病药事服务专区
   */
  {
    path: '/renewal/ill',
    component: () => import('./views/ill')
  },
  /**
   * 处方支付
   */
  {
    path: '/renewal/pay',
    component: () => import('./pay')
  }
]



// WEBPACK FOOTER //
// ./src/page/renewal/renewal.js